import styled from "styled-components";

export const CategoryWrapper = styled.div`
  min-height: 682px;
  background-color: #fff;
  padding-top: 96px;
  padding-bottom: 104px;
  @media (max-width: 960px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  @media (max-width: 400px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;
